import axios from '@/plugins/axios'
import { Message, MessageBox } from 'element-ui'
import isEmpty from 'lodash/isEmpty'
import format from "date-fns/format";

export default {
  namespaced: true,

  state: {
    loading: false,
    users: [],
    services: [],
    labels: [],
    artists: [],
    companyAdmins: [],
    countries: [],
    validation: [],
    page: 1,
    page_size: 10,
    order_column: 'created_at',
    order_type: 'desc',
    dialog: false,
    dialog_select_tier: false,
    user: {
      id: null,
      email: null,
      first_name: null,
      surname: null,
      slug: null,
      user_level: null,
      label: null,
      artist: null,
      company_admin: null,
      country_of_residence: null,
      wallet: null,
      featured: null,
      image_url: null,
      address: null,
      name: null,
      phone: null,
      biography: null,
      quote: null,
      birthday: null,
      permission: null,
    },
    shareCompanyAdmin: false,
    showWallet: true,
    ytCategories: [],
    creatorTiers: [],
    csvLoading: false
  },

  getters: {
    isUserWallet(state) {
      return [
        'sysadmin',
        'company_user',
        'user',
        'company_admin',
        'creator'
      ].includes(state.user.user_level)
    },
    isLabelWallet(state) {
      return ['artist_admin', 'label_admin'].includes(state.user.user_level)
    }
  },

  mutations: {
    setUsers(state, payload) {
      state.users = payload
    },
    setServices(state, payload) {
      state.services = payload
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setSelectedUser(state, payload) {
      state.user = payload
    },
    setDialog(state, payload) {
      state.dialog = payload
    },
    setTierDialog(state, payload) {
      state.dialog_select_tier = payload
    },
    setLabels(state, payload) {
      state.labels = payload
    },
    setArtists(state, payload) {
      state.artists = payload
    },
    setCompanyAdmin(state, payload) {
      state.companyAdmins = payload
    },
    setCountry(state, payload) {
      state.countries = payload
    },
    setValidation(state, payload) {
      state.validation = payload
    },
    setWallet(state, amount) {
      state.user.wallet = amount
    },
    setShowWallet(state, status) {
      state.showWallet = status
    },
    setImage(state, image) {
      state.user.image_url = image
    },
    setYoutubeCategories(state, categories) {
      state.ytCategories = categories
    },
    setTiers(state, tiers) {
      state.creatorTiers = tiers
    },
    setShareCompanyAdmin(state, bool) {
      state.shareCompanyAdmin = bool
    },
    setAmountDescription(state, text) {
      state.user.amountDescription = text
    },
    setCsvLoading(state, bool) {
      state.csvLoading = bool
    }
  },

  actions: {
    read({ commit, state }, filters = null) {
      commit('setLoading', true)

      let ls = localStorage.getItem('user_filter')
      filters = ls ? JSON.parse(ls) : {}
      filters.company_admin = ''

      axios.admin
        .get('user', {
          params: {
            page: state.page,
            page_size: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type,
            ...filters
          }
        })
        .then(r => {
          r.data.data.data.map(s => {
            if (s.wallet !== null) {
              s.wallet = s.wallet/10
            }
            if (!s.channels.youtube || s.channels.youtube.approved !== 1) {
              s.creator_tier = null
            }
          })
          commit('setUsers', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    readServices({ commit, state },id) {
      commit('setLoading', true)

      axios.admin
          .get('services?id='+id)
          .then(r => {
            commit('setServices', r.data.data)
            commit('setLoading', false)
          })
          .catch(() => {
            commit('setLoading', false)
          })
    },
    async updateUserService({ commit, dispatch }, data) {
      try {
        commit('setLoading', true)
        const response = await axios.admin.post('services', data)

        if (response) {
          commit('setLoading', true)
        }
      }
      catch (e) {
        commit('setLoading', false)
      }
    },
    async updateSocialNetworkStatus({ commit, dispatch }, data) {
      try {
        commit('setLoading', true)
        commit('creatorUsers/setLoading', true, { root: true })
        commit('mcnUsers/setLoading', true, { root: true })
        const response = await axios.admin.post('vc/approve-channel', data)

        if (response) {
          dispatch('read')
          commit('setLoading', true)
          commit('creatorUsers/setLoading', true, { root: false })
          commit('mcnUsers/setLoading', true, { root: false })
        }
      }
       catch (e) {
         commit('setLoading', false)
         commit('creatorUsers/setLoading', true, { root: false })
         commit('mcnUsers/setLoading', true, { root: false })
      }
    },
    async update({ commit, dispatch, state },oldWallet) {
      let user = {
        ...state.user,
        confirm: false
      }
      try {
        let wallet_change = user.wallet-oldWallet
        user.wallet = user.wallet*10
        const isWalletChanged = await dispatch('updateUser', user)
        if (!isWalletChanged.success && isWalletChanged.walletChanged) {
          const throwWarning = await MessageBox.confirm(
            `Please confirm adding $${(wallet_change)} to this wallet`,
            'Warning',
            {
              confirmButtonText: 'OK',
              cancelButtonText: 'Cancel',
              type: 'warning'
            }
          )
          if (throwWarning) {
            user.confirm = true
            const updateUser = await dispatch('updateUser', user)

            if (updateUser) dispatch('handleUserDialogAfterSuccess')
          }
        }
        dispatch('handleUserDialogAfterSuccess')
      } catch (err) {
        commit('setLoading', false)
      }
    },

    updateUser(context, payload) {
      return new Promise((res, rej) => {
        axios.admin
          .put('user', {...payload, shareCompanyAdmin: context.state.shareCompanyAdmin})
          .then(({ data }) => {
            res(data)
          })
          .catch(err => {
            rej(err)
          })
      })
    },
    handleUserDialogAfterSuccess({ commit, dispatch }) {
      commit('setLoading', false)
      commit('setDialog', false)
      commit('setSelectedUser', {})
      dispatch('read')
      dispatch('getCompanyAdminArtist')
    },
    insert({ commit, dispatch, state }) {
      axios.admin
        .post('user', {
          email: state.user.email,
          first_name: state.user.first_name,
          surname: state.user.surname,
          country: state.user.country_of_residence,
          artist: state.user.artist,
          label: state.user.label,
          user_level: state.user.user_level,
          user_tier: state.user.user_tier,
          company_admin: state.user.company_admin,
          name: state.user.name,
          biography: state.user.biography,
          quote: state.user.quote,
          phone: state.user.phone,
          address: state.user.address,
          birthday: state.user.birthday,
          featured: state.user.featured,
          leaderboard: state.user.leaderboard,
          spotlight: state.user.spotlight,
          permission: state.user.permission,
          shareCompanyAdmin: state.shareCompanyAdmin
        })
        .then(() => {
          commit('setDialog', false)
          dispatch('read')
          dispatch('getCompanyAdminArtist')
        })
        .catch(err => {
          if (
            err.response.data &&
            !isEmpty(err.response.data.errors.validation)
          ) {
            commit('setValidation', err.response.data.errors.validation)
          } else if (err.response.data && err.response.data.response.message) {
            Message({
              type: 'error',
              message: err.response.data.response.message
            })
            commit('setDialog', false)
          }
        })
    },
    delete({ dispatch }, id) {
      return new Promise((resolve, reject) => {
        axios.admin
          .put('user/delete/' + id)
          .then(data => {
            dispatch('read')
            resolve(data)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    async deleteImage({ commit, state, dispatch }) {
      const alert = await MessageBox.confirm(
        'This action will permanently delete user profile picture?',
        'Warning',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
      if (alert) {
        const deleteImage = await axios.admin.post(
          `user/image/upload/${state.user.id}`,
          { image: null }
        )
        if (deleteImage.data.success) {
          commit('setImage', null)
          dispatch('read')

          Message({
            type: 'success',
            message: 'You have successfully deleted image'
          })
        }
      }
    },
    getLabel({ commit }) {
      commit('setLoading', true)
      axios.admin
        .get('user/label')
        .then(r => {
          commit('setLabels', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    getArtist({ commit }) {
      commit('setLoading', true)
      axios.admin
        .get('user/artist')
        .then(r => {
          commit('setArtists', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    getCompanyAdminArtist({ commit }) {
      commit('setLoading', true)
      axios.admin
        .get('user/company-admin')
        .then(r => {
          commit('setCompanyAdmin', r.data.mcnUsers)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    getCountry({ commit }) {
      commit('setLoading', true)
      axios.admin
        .get('user/country')
        .then(r => {
          commit('setCountry', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    exportCSV({ state, commit }, filters) {
      commit('setCsvLoading', true)
      axios.admin
        .get('user', {
          params: {
            page: state.page,
            page_size: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type,
            ...filters
          },
          responseType: 'blob'
        })
        .then(r => {
          const url = window.URL.createObjectURL(new Blob([r.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'user_export.csv')
          document.body.appendChild(link)
          link.click()
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => { commit('setCsvLoading', false) })
    },
    tierChangeTemplate() {
      axios.admin
        .get('user/csv/download', {
          responseType: 'blob'
        })
        .then(r => {
          const url = window.URL.createObjectURL(new Blob([r.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'tier_change_template.csv')
          document.body.appendChild(link)
          link.click()
        })
        .catch(e => {
          console.log(e)
        })
    },
    getCidContract({ state }, id) {
      axios.admin
          .get('contracts/'+id, {
            responseType: 'blob'
          })
          .then(r => {
            const url = window.URL.createObjectURL(new Blob([r.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'cid_contract_'+id+'.pdf')
            document.body.appendChild(link)
            link.click()
          })
          .catch(e => {
            console.log(e)
          })
    },
    getDistroContract({ state }, id) {
      axios.admin
          .get('contracts/distro/'+id, {
            responseType: 'blob'
          })
          .then(r => {
            const url = window.URL.createObjectURL(new Blob([r.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'distro_contract_'+id+'.pdf')
            document.body.appendChild(link)
            link.click()
          })
          .catch(e => {
            console.log(e)
          })
    }
  }
}
